import claimed from '../../../assets/claimed.png';
function ClaimedCertificate({ image, ic }) {
    console.log(ic, 'ic in claimed certificate');
    return (
        <div className="w-full h-full relative">
            <img className="w-full rounded-lg h-full" src={image} alt="claimed-card" />
            {ic?.blockchain?.image && (
                <img
                    className="absolute w-5 h-5 rounded-full bottom-[.625rem] right-[.625rem]"
                    src={ic?.blockchain?.image}
                    alt={ic?.blockchain?.name}
                />
            )}
        </div>
    );
}

export default ClaimedCertificate;
